import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../../constants/common'
import { InputField } from '../../../Input'
import { QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_SEARCH } from '../../DashboardBirdview.constants.qa'
import { BirdviewChartCatalogTab } from '../BirdviewChartCatalogTab'

import * as styles from './BirdviewChartCatalogHeader.module.css'

import SearchIcon from '../../../../icons/search.svg'

function BirdviewChartCatalogHeader({
  activeTab,
  search,
  tabs,
  onChangeSearch,
  onSelectTab,
}) {
  const { t } = useTranslation()

  function handleChangeSearch(event) {
    onChangeSearch(event.target.value)
  }

  function handleClearSearch() {
    onChangeSearch(EMPTY_STRING)
  }

  return (
    <div className={styles.header}>
      <InputField
        beforeIconProps={{ Icon: SearchIcon }}
        placeholder={t('DashboardBirdview.ChartCatalogSearchPlaceholderKey')}
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_SEARCH}
        showError={false}
        value={search}
        onChange={handleChangeSearch}
        onClear={handleClearSearch}
      />
      <div className={styles.tabs}>
        {tabs.map(tab => (
          <BirdviewChartCatalogTab
            isActive={tab.value === activeTab}
            key={tab.value}
            tab={tab}
            onSelect={onSelectTab}
          />
        ))}
      </div>
    </div>
  )
}

export default BirdviewChartCatalogHeader
